// @flow

const cache: { [times: number]: RegExp } = {};

export function timesGroupFormatter(times: number = 1, value?: ?string = '', separator?: ?string): string {
  return timesGroupSplitter(times, value).join(separator || ' ');
}

export function timesGroupSplitter(times: number = 1, value?: ?string = ''): string[] {
  if (!value) {
    return [];
  }

  const regexp = (cache[times] = cache[times] || new RegExp(`(?:.{1,${times}})`, 'g'));

  return value.match(regexp) || [];
}

export function timesGroupSlicer(times: number = 1, value?: ?ImmutableArray<string> = []): string[][] {
  if (!value) {
    return [];
  }

  const groups: string[][] = [];

  for (let i = 0, group; (group = value.slice(i, i + times)).length; i += times) {
    groups.push(group);
  }
  return groups;
}

export type DecimalFormatterArgs = {|
  thousandsSeparator: string,
  decimalSeparator: string,
|};

export function decimalFormatter(args: DecimalFormatterArgs): (string) => string {
  const { thousandsSeparator, decimalSeparator } = args;
  return (value: string) => {
    if (!/^(\d+)$|^(\d*\.\d+)$|^(\d+\.\d*)$/.test(value)) {
      throw new Error(`Invalid input value: ${value}`);
    }
    const [intPart, decimalPart] = value.split('.');
    const intDigits = [];
    if (!intPart || !intPart.length) {
      intDigits.push('0');
    } else {
      for (let i = intPart.length, j = 0; i >= 0; i--, j++) {
        intDigits.unshift(intPart[i]);
        if (j > 0 && i !== 0 && j % 3 == 0 ) {
          intDigits.unshift(thousandsSeparator);
        }
      }
    }
    const intValue = intDigits.join('');
    const decimalValue = decimalPart
      ? (decimalPart.length == 1 ? decimalPart + '0' : decimalPart)
      : '00';
    return `${intValue}${decimalSeparator}${decimalValue}`;
  };
}
